import { gql } from '@apollo/client'

export const GOAL_UPDATES = gql`
  query GoalUpdates(
    $goalId: Int
    $nonprofitOrgId: Int
    $sort: GoalUpdateSortOptions
  ) {
    goalUpdates(goalId: $goalId, nonprofitOrgId: $nonprofitOrgId, sort: $sort) {
      nodes {
        id
        goalId
        goalTitle
        description
        lastUpdatedUserId
        lastUpdatedUserFirstname
        lastUpdatedUserLastname
        taskId
        taskTitle
        reportedAt
      }
    }
  }
`
